import { InjectionToken } from '@angular/core';
import { NgControl } from '@angular/forms';

export interface FormErrorsFormatter {
  format(control: NgControl): string;
}

export const FORM_ERRORS_FORMATTER = new InjectionToken<FormErrorsFormatter>('FORM_ERRORS_FORMATTER');

export const provideFormErrorsFormatter = (errorsFormatter: FormErrorsFormatter) => ({
  provide: FORM_ERRORS_FORMATTER,
  useValue: errorsFormatter,
});
